<section class="hucu-dialog hucu-dialog--backlog">
  <header class="hucu-dialog__header">
    <div>
      <p class="hucu-dialog__eyebrow">Planificación ágil</p>
      <h2>Historias de usuario del sprint</h2>
      <p>Arrastre las historias pendientes para asignarlas al sprint seleccionado.</p>
    </div>
    <button type="button" mat-icon-button class="hucu-dialog__close" (click)="onNoClick()"
      aria-label="Cerrar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div mat-dialog-content class="hucu-dialog__content">
    <div *ngIf="!panelEditable" class="hucu-dialog__notice">
      El sprint está {{ estatusSprint }}; no se permiten cambios en las historias asignadas.
    </div>

    <div class="hucu-backlog__board">
      <section class="hucu-backlog__column">
        <header class="hucu-backlog__column-header">
          <h3>Historias pendientes</h3>
          <span>{{ resourcesFilterHistoriasU?.length || 0 }}</span>
        </header>
        <div #scrollElementContentHU cdk-scrollable class="hucu-backlog__list-wrap">
          <div cdkDropList [cdkDropListDisabled]="!panelEditable" #HUPendienteList="cdkDropList"
            [cdkDropListData]="resourcesFilterHistoriasU" [cdkDropListConnectedTo]="[doneHistoriasUList]"
            class="hucu-backlog__list" (cdkDropListDropped)="dropHistoriasU($event)">
            <div class="hucu-backlog__item" *ngFor="let item of resourcesFilterHistoriasU" cdkDrag>
              <span>{{ item.nombre }}</span>
              <mat-icon>description</mat-icon>
            </div>
          </div>
        </div>
      </section>

      <section class="hucu-backlog__column">
        <header class="hucu-backlog__column-header">
          <h3>Historias asignadas</h3>
          <span>{{ doneHistoriasU?.length || 0 }}</span>
        </header>
        <div #scrollEl cdk-scrollable class="hucu-backlog__list-wrap">
          <div cdkDropList [cdkDropListDisabled]="!panelEditable" #doneHistoriasUList="cdkDropList"
            [cdkDropListData]="doneHistoriasU" [cdkDropListConnectedTo]="[HUPendienteList]"
            class="hucu-backlog__list" (cdkDropListDropped)="dropHistoriasU($event)">
            <div class="hucu-backlog__item" *ngFor="let item of doneHistoriasU" cdkDrag>
              <span>{{ item.nombre }}</span>
              <div class="hucu-backlog__item-actions">
                <mat-icon>description</mat-icon>
                <button *ngIf="panelEditable" type="button" mat-icon-button (click)="removeAsignados(item)"
                  matTooltip="Quitar asignación" aria-label="Quitar asignación">
                  <mat-icon>cancel</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <footer class="hucu-dialog__footer">
    <button type="button" mat-button class="app-form-btn app-form-btn--secondary" (click)="onNoClick()">Cancelar</button>
    <button *ngIf="panelEditable" type="button" mat-button class="app-form-btn app-form-btn--primary" (click)="save()">
      Guardar asignación
    </button>
  </footer>
</section>
